import { o as a } from "../../unsafe-svg-By8nNw37.js";
import { i, x as p } from "../../lit-element-6iugfgmM.js";
import { S as d } from "../../Base-pdJ5fkYW.js";
import { e as x } from "../../custom-element-wk-AooBb.js";
const g = i`#Layer_1{height:20px}`;
var h = Object.defineProperty, v = Object.getOwnPropertyDescriptor;
let r = class extends d {
  static get styles() {
    return g;
  }
  render() {
    return p`${a(`<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 26.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 18 18" style="enable-background:new 0 0 18 18;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#6E6E6E;}
	.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#6E6E6E;}
</style>
<g>
	<g id="I_C_O_N_S">
		<path class="st0" d="M3.9,6.9L2.7,9.5c0,0,0,0-0.1,0H1.9c0,0-0.1,0,0-0.1l3.4-7.4c0.1-0.2,0.1-0.3,0.1-0.5c0,0,0-0.1,0-0.1h1
			c0,0,0,0,0.1,0.1l0.9,7.9c0,0.1,0,0.1,0,0.1H6.7c-0.1,0-0.1,0-0.1-0.1L6.3,6.9H3.9z M6.2,6.1C6,4.4,5.9,2.8,5.9,2.3h0
			c-0.1,0.5-1,2.5-1.6,3.8H6.2z"/>
		<path class="st0" d="M10.8,7.9l-0.5,1.5c0,0.1-0.1,0.1-0.2,0.1c0,0,0,0,0,0H8.4c-0.1,0-0.1-0.1-0.1-0.2l2.3-6.9
			c0.1-0.3,0.1-0.6,0.1-0.9c0,0,0-0.1,0.1-0.1c0,0,0,0,0,0h2.4c0.1,0,0.1,0,0.1,0.1l2.7,7.8c0,0.1,0,0.1-0.1,0.1h-2
			c-0.1,0-0.1,0-0.1-0.1l-0.5-1.5H10.8z M12.9,6.1c-0.2-0.8-0.6-1.9-0.8-2.8h0c-0.2,0.9-0.5,2-0.8,2.8H12.9z"/>
	</g>
	<path class="st1" d="M16.9,13.7c0-0.1-0.1-0.2-0.2-0.2H8c-0.3-1.3-1.6-2.2-2.9-1.9c-1,0.2-1.7,1-1.9,1.9H1.3
		c-0.1,0-0.2,0.1-0.2,0.2v0.5c0,0.1,0.1,0.2,0.2,0.2h1.8c0.3,1.3,1.6,2.2,2.9,1.9c1-0.2,1.7-1,1.9-1.9h8.7c0.1,0,0.2-0.1,0.2-0.2
		V13.7z M5.5,15.5C4.7,15.5,4,14.8,4,14s0.7-1.5,1.5-1.5S7,13.2,7,14S6.4,15.5,5.5,15.5L5.5,15.5z"/>
</g>
</svg>
`)}`;
  }
};
r = ((o, e, c, n) => {
  for (var s, t = n > 1 ? void 0 : n ? v(e, c) : e, l = o.length - 1; l >= 0; l--) (s = o[l]) && (t = (n ? s(e, c, t) : s(t)) || t);
  return n && t && h(e, c, t), t;
})([x("af-variable-font-icon")], r);
const y = r;
export {
  y as default
};
//# sourceMappingURL=VariableFontIcon.js.map
